import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">热播排行榜</h2>
          <p className="text-sm text-foreground-500 mt-3">实时更新的热门影视排行</p>
        </div>
        <div className="space-y-3">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/50 hover:border-primary-500/20 transition-all cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400/80 text-background-50' :
                item.rank === 3 ? 'bg-primary-300/60 text-background-50' :
                'bg-background-200 text-foreground-400'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-100">{item.title}</h3>
                  <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                    item.tag === '爆' ? 'bg-primary-500/15 text-primary-400' :
                    item.tag === '热' ? 'bg-accent-500/15 text-accent-400' :
                    item.tag === '新' ? 'bg-secondary-500/15 text-secondary-400' :
                    'bg-background-300/50 text-foreground-500'
                  }`}>{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">{item.type}</p>
              </div>
              <div className="flex items-center gap-1.5 flex-shrink-0">
                <i className="ri-fire-line text-accent-500 text-sm"></i>
                <span className="text-sm font-semibold text-accent-400">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}